/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".abc.messenger.ws.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 28);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["f"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["e"] = __decorate;
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["b"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(49);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__http__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(37);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(46);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__decorators__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__decorators__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__decorators__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logging__ = __webpack_require__(52);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__logging__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__logging__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__logging__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__leadsraiser__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__exceptions__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__misc__ = __webpack_require__(14);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__misc__["b"]; });








//# sourceMappingURL=index.js.map

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logging_Trace__ = __webpack_require__(13);


var BaseComponent = /** @class */ (function () {
    function BaseComponent(options) {
        this.destroyed = false;
        this.extendOptions(options);
    }
    BaseComponent.prototype.build = function (childNodes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var hostElement;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.render(childNodes)];
                    case 1:
                        hostElement = _a.sent();
                        this.id = BaseComponent.lastComponentId++;
                        this.hostElement = $(hostElement);
                        this.hostElement
                            .attr('data-xmid', this.id)
                            .data('component', this);
                        return [2 /*return*/, hostElement];
                }
            });
        });
    };
    BaseComponent.prototype.destroy = function () {
        if (this.destroyed)
            return;
        this.getChildComponents()
            .forEach(function (component) { return component.destroy(); });
        this.getHostElement()
            .removeAttr('data-xmid')
            .data('component', null);
        this.destroyed = true;
    };
    BaseComponent.prototype.fireEvent = function (eventName) {
        var eventArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            eventArgs[_i - 1] = arguments[_i];
        }
        if (!this.getEventTarget())
            return;
        this.getEventTarget().trigger(eventName, [this].concat(eventArgs));
    };
    BaseComponent.prototype.fireHandler = function (eventName) {
        var eventArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            eventArgs[_i - 1] = arguments[_i];
        }
        if (!this.getHostElement())
            return;
        this.getHostElement().triggerHandler(eventName, [this].concat(eventArgs));
    };
    BaseComponent.prototype.broadcastEvent = function (eventName, selector) {
        var eventArgs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            eventArgs[_i - 2] = arguments[_i];
        }
        if (!this.getHostElement())
            return;
        this.getHostElement().find(selector).trigger(eventName, [this].concat(eventArgs));
    };
    BaseComponent.prototype.getComponentId = function () {
        return this.id;
    };
    BaseComponent.prototype.getHostElement = function () {
        return this.hostElement;
    };
    BaseComponent.prototype.getHostElementSize = function () {
        var hostContainer = this.hostElement.parent();
        var className = hostContainer.attr('class');
        var dummyContainer = $('<div style="visibility: hidden;"></div>').addClass(className).insertAfter(hostContainer);
        var dummyElement = this.hostElement.clone().detach();
        this.prepareHostElementForSizeCalculation(dummyElement, dummyContainer);
        dummyElement.appendTo(dummyContainer);
        var result = this.calculateHostElementSize(dummyElement);
        dummyContainer.remove();
        return result;
    };
    BaseComponent.prototype.prepareHostElementForSizeCalculation = function (dummyElement, dummyContainer) {
        dummyElement.css({
            position: 'static',
            display: ''
        });
    };
    BaseComponent.prototype.calculateHostElementSize = function (dummyElement) {
        return {
            width: dummyElement.outerWidth(),
            height: dummyElement.outerHeight()
        };
    };
    BaseComponent.prototype.onMount = function () {
    };
    BaseComponent.prototype.getChildComponents = function () {
        return this.getHostElement()
            .find('[data-xmid]')
            .toArray()
            .map(function (elem) { return $(elem).data('component'); })
            .filter(function (component) { return component != null; });
    };
    BaseComponent.prototype.extendOptions = function (extendedOptions) {
        this.options = $.extend(true, this.getDefaultOptions(), extendedOptions);
    };
    BaseComponent.prototype.getEventTarget = function () {
        return this.getHostElement();
    };
    BaseComponent.prototype.getDefaultOptions = function () {
        return {};
    };
    BaseComponent.prototype.cls = function () {
        var classes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classes[_i] = arguments[_i];
        }
        return classes.filter(function (cls) { return cls; }).join(' ');
    };
    BaseComponent.lastComponentId = 0;
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__logging_Trace__["a" /* Trace */])()
    ], BaseComponent.prototype, "fireEvent", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__logging_Trace__["a" /* Trace */])()
    ], BaseComponent.prototype, "fireHandler", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__logging_Trace__["a" /* Trace */])()
    ], BaseComponent.prototype, "broadcastEvent", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__logging_Trace__["a" /* Trace */])()
    ], BaseComponent.prototype, "extendOptions", null);
    return BaseComponent;
}());

//# sourceMappingURL=BaseComponent.js.map

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogLevel; });
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warn"] = 3] = "Warn";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Fatal"] = 5] = "Fatal";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=LogLevel.js.map

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setMetadata;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMetadata;
/* unused harmony export hasMetadata */
var metadata = [];
function setMetadata(targetClass, metadataKey, metadataValue, targetProperty) {
    metadata.push({
        targetClass: targetClass,
        metadataKey: metadataKey,
        metadataValue: metadataValue,
        targetProperty: targetProperty
    });
}
function getMetadata(targetClass, metadataKey, targetProperty) {
    var targetMetadata = metadata.filter(function (item) { return item.targetClass === targetClass
        && (!metadataKey || item.metadataKey === metadataKey)
        && (!targetProperty || item.targetProperty === targetProperty); });
    var metadataValue = targetMetadata
        ? targetMetadata.map(function (item) { return item.metadataValue; })
        : [];
    var parent = getPrototypeOf(targetClass);
    if (parent) {
        var parentMetadata = getMetadata(parent, metadataKey);
        if (parentMetadata && parentMetadata.length) {
            metadataValue.push.apply(metadataValue, parentMetadata);
        }
    }
    return metadataValue && metadataValue.length ? metadataValue : undefined;
}
function hasMetadata(targetClass, metadataKey) {
    return !!getMetadata(targetClass, metadataKey);
}
// http://ejohn.org/blog/objectgetprototypeof/
if (typeof Object.getPrototypeOf !== "function") {
    Object.getPrototypeOf = "".__proto__ === String.prototype
        ? function (object) { return object.__proto__; }
        : function (object) { return object.constructor.prototype; };
}
// https://github.com/rbuckton/ReflectDecorators
var functionPrototype = Object.getPrototypeOf(Function);
function getPrototypeOf(obj) {
    var proto = Object.getPrototypeOf(obj);
    if (typeof obj !== "function" || obj === functionPrototype) {
        return proto;
    }
    if (proto !== functionPrototype) {
        return proto;
    }
    var prototype = obj.prototype;
    var prototypeProto = prototype && Object.getPrototypeOf(prototype);
    if (prototypeProto == null || prototypeProto === Object.prototype) {
        return proto;
    }
    var constructor = prototypeProto.constructor;
    if (typeof constructor !== "function") {
        return proto;
    }
    if (constructor === obj) {
        return proto;
    }
    return constructor;
}
//# sourceMappingURL=Metadata.js.map

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["a"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["c"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["d"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["b"] = isString;
/* unused harmony export isObject */
/* unused harmony export isArray */
/* harmony export (immutable) */ __webpack_exports__["f"] = getTypeName;
/* unused harmony export getFunctionName */
function isFunction(func) {
    return typeof func === "function";
}
function isUndefined(obj) {
    return typeof obj === "undefined";
}
function isNumber(num) {
    return typeof num === "number";
}
function isBoolean(bool) {
    return typeof bool === "boolean";
}
function isString(str) {
    return typeof str === "string";
}
function isObject(obj) {
    return obj !== null && typeof obj === "object";
}
function isArray(array) {
    return $.isArray(array);
}
function getTypeName(obj) {
    if (isUndefined(obj))
        return "undefined";
    if (obj == null)
        return "null";
    return getFunctionName(obj.constructor);
}
var functionNameRegex = new RegExp('function (.{1,})\\(');
function getFunctionName(func) {
    if (func == null)
        return null;
    if ('name' in func)
        return func.name;
    var match = functionNameRegex.exec(func.toString());
    return (match && match.length > 1)
        ? match[1]
        : "";
}
//# sourceMappingURL=typeUtils.js.map

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerError;
function registerError(e, message) {
    if (message === void 0) { message = ""; }
    var lr = window.lr;
    if (!lr || !lr.api) {
        console.error(message, e);
        return;
    }
    var errorData = {
        source: 'abc.messenger'
    };
    if (e instanceof Error) {
        lr.api.registerException(e, errorData);
    }
    else {
        lr.api.registerError(e, null, errorData);
    }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseComponent__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IntrinsicComponent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata_Metadata__ = __webpack_require__(4);




var Component = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.build = function (childNodes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var hostElement;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.build.call(this, childNodes)];
                    case 1:
                        hostElement = _a.sent();
                        this.resolveElementRefs();
                        this.bindToEvents();
                        return [2 /*return*/, hostElement];
                }
            });
        });
    };
    Component.prototype.destroy = function () {
        if (this.destroyed)
            return;
        this.unbindFromEvents();
        _super.prototype.destroy.call(this);
    };
    Component.prototype.getEventNameSpace = function () {
        return "component_" + this.getComponentId();
    };
    Component.prototype.bindToEvents = function () {
        var metadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata_Metadata__["b" /* getMetadata */])(this, 'EventListener');
        if (!metadata)
            return;
        for (var _i = 0, metadata_1 = metadata; _i < metadata_1.length; _i++) {
            var listenerMetadata = metadata_1[_i];
            var fullEventName = listenerMetadata.eventName + "." + this.getEventNameSpace();
            if (listenerMetadata.selector) {
                if (typeof listenerMetadata.selector === "string") {
                    this.getHostElement().on(fullEventName, listenerMetadata.selector, this.getMember(listenerMetadata.handler).bind(this));
                }
                else {
                    $(listenerMetadata.selector).on(fullEventName, this.getMember(listenerMetadata.handler).bind(this));
                }
            }
            else {
                this.getHostElement().on(fullEventName, this.getMember(listenerMetadata.handler).bind(this));
            }
        }
    };
    Component.prototype.getMember = function (name) {
        return this[name];
    };
    Component.prototype.resolveElementRefs = function () {
        var metadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata_Metadata__["b" /* getMetadata */])(this, 'ElementReference');
        if (!metadata)
            return;
        for (var _i = 0, metadata_2 = metadata; _i < metadata_2.length; _i++) {
            var reference = metadata_2[_i];
            this[reference.handler] = this.getHostElement().find(reference.selector);
        }
    };
    Component.prototype.unbindFromEvents = function () {
        this.getHostElement().off("." + this.getEventNameSpace());
        var metadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata_Metadata__["b" /* getMetadata */])(this, 'EventListener');
        if (!metadata)
            return;
        for (var _i = 0, metadata_3 = metadata; _i < metadata_3.length; _i++) {
            var listenerMetadata = metadata_3[_i];
            if (listenerMetadata.selector) {
                $(listenerMetadata.selector).off("." + this.getEventNameSpace());
            }
        }
    };
    Component.render = function (node, options) {
        var childNodes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            childNodes[_i - 2] = arguments[_i];
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var component, hostElement;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        component = typeof node === "string"
                            ? new __WEBPACK_IMPORTED_MODULE_2__IntrinsicComponent__["a" /* IntrinsicComponent */](node, options)
                            : new node(options);
                        return [4 /*yield*/, component.build(childNodes)];
                    case 1:
                        hostElement = _a.sent();
                        Component.renderedComponents.push(component);
                        return [2 /*return*/, hostElement];
                }
            });
        });
    };
    Component.mount = function (component, container, replaceContainer, clearContent) {
        if (replaceContainer === void 0) { replaceContainer = true; }
        if (clearContent === void 0) { clearContent = true; }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var content;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, component];
                    case 1:
                        content = _a.sent();
                        if (replaceContainer) {
                            container.replaceWith(content);
                        }
                        else {
                            if (clearContent) {
                                container.empty();
                            }
                            container.append(content);
                        }
                        setTimeout(function () {
                            Component.mountRenderedComponents();
                        });
                        return [2 /*return*/, content];
                }
            });
        });
    };
    Component.mountRenderedComponents = function () {
        Component.renderedComponents.forEach(function (component) { return component.onMount && component.onMount(); });
        Component.renderedComponents = [];
    };
    Component.renderedComponents = [];
    return Component;
}(__WEBPACK_IMPORTED_MODULE_1__BaseComponent__["a" /* BaseComponent */]));

//# sourceMappingURL=Component.js.map

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemorySessionStorage; });
var MemorySessionStorage = /** @class */ (function () {
    function MemorySessionStorage(category) {
        this.category = category;
        MemorySessionStorage.storage[this.category] = MemorySessionStorage.storage[this.category] || {};
    }
    MemorySessionStorage.prototype.clear = function () {
        MemorySessionStorage.storage[this.category] = {};
    };
    MemorySessionStorage.prototype.getAll = function () {
        return MemorySessionStorage.storage[this.category];
    };
    MemorySessionStorage.prototype.getItem = function (key) {
        return MemorySessionStorage.storage[this.category][key];
    };
    MemorySessionStorage.prototype.setItem = function (key, value) {
        MemorySessionStorage.storage[this.category][key] = value;
    };
    MemorySessionStorage.prototype.setRaw = function (state) {
        MemorySessionStorage.storage[this.category] = state;
    };
    MemorySessionStorage.prototype.removeItem = function (key) {
        delete MemorySessionStorage.storage[this.category][key];
    };
    MemorySessionStorage.storage = {};
    return MemorySessionStorage;
}());

//# sourceMappingURL=MemorySessionStorage.js.map

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Exception = function (message) {
    this.name = this.constructor.name;
    this.message = message;
    Error.call(this, message);
    if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }
    else {
        this.stack = (new Error()).stack;
    }
};
Exception.prototype = Object.create(Error.prototype);
/* harmony default export */ __webpack_exports__["a"] = (Exception);
//# sourceMappingURL=Exception.js.map

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpException; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exceptions_Exception__ = __webpack_require__(9);


var HttpException = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](HttpException, _super);
    function HttpException(status, message, innerException) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.innerException = innerException;
        return _this;
    }
    return HttpException;
}(__WEBPACK_IMPORTED_MODULE_1__exceptions_Exception__["a" /* default */]));

//# sourceMappingURL=HttpException.js.map

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lr; });
var lr = window['lr'];
//# sourceMappingURL=index.js.map

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogLevel__ = __webpack_require__(3);

var ConsoleFunction = /** @class */ (function () {
    function ConsoleFunction(name, messagePrefix) {
        if (messagePrefix === void 0) { messagePrefix = false; }
        this.name = name;
        this.messagePrefix = messagePrefix;
    }
    ConsoleFunction.prototype.call = function (console, level, message, data) {
        var resultMessage = message;
        if (this.messagePrefix) {
            resultMessage = __WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */][level] + ": " + message;
        }
        console[this.name](resultMessage, data);
    };
    ConsoleFunction.prototype.canBeCalled = function (console) {
        return console && (this.name in console);
    };
    return ConsoleFunction;
}());
var consoleFunctionsMap = {};
consoleFunctionsMap[__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Trace] = new ConsoleFunction('log');
consoleFunctionsMap[__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Debug] = new ConsoleFunction('log', true);
consoleFunctionsMap[__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Info] = new ConsoleFunction('info');
consoleFunctionsMap[__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Warn] = new ConsoleFunction('warn');
consoleFunctionsMap[__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Error] = new ConsoleFunction('error');
consoleFunctionsMap[__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Fatal] = new ConsoleFunction('error', true);
var defaultConsoleFunction = new ConsoleFunction('log', true);
var Logger = /** @class */ (function () {
    function Logger(console, minLogLevelToDisplay) {
        if (minLogLevelToDisplay === void 0) { minLogLevelToDisplay = __WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Warn; }
        this.console = console;
        this.minLogLevelToDisplay = minLogLevelToDisplay;
    }
    Logger.prototype.canDisplayMessageFor = function (logLevel) {
        return this.console && this.minLogLevelToDisplay != null && this.minLogLevelToDisplay <= logLevel;
    };
    Logger.prototype.trace = function (message, data) {
        this.log(__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Trace, message, data);
    };
    Logger.prototype.debug = function (message, data) {
        this.log(__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Debug, message, data);
    };
    Logger.prototype.info = function (message, data) {
        this.log(__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Info, message, data);
    };
    Logger.prototype.warn = function (message, data) {
        this.log(__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Warn, message, data);
    };
    Logger.prototype.error = function (message, data) {
        this.log(__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Error, message, data);
    };
    Logger.prototype.fatal = function (message, data) {
        this.log(__WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Fatal, message, data);
    };
    Logger.prototype.log = function (level, message, data) {
        if (!this.canDisplayMessageFor(level))
            return;
        var logFunction = consoleFunctionsMap[level];
        if (logFunction == null) {
            if (defaultConsoleFunction.canBeCalled(this.console)) {
                defaultConsoleFunction.call(this.console, __WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Fatal, 'Unsupported log level', level);
            }
            else {
                return;
            }
            logFunction = defaultConsoleFunction;
        }
        else if (!logFunction.canBeCalled(this.console)) {
            if (!defaultConsoleFunction.canBeCalled(this.console))
                return;
            logFunction = defaultConsoleFunction;
        }
        logFunction.call(this.console, level, message, data);
    };
    Logger.prototype.enabledFor = function (level) {
        return this.canDisplayMessageFor(level);
    };
    return Logger;
}());
var logger = new Logger(window.console, window.xmMinLogLevel);
//# sourceMappingURL=Logger.js.map

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Trace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogLevel__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logger__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__ = __webpack_require__(5);



var maxValueStringLength = 30;
function stringifyValue(value) {
    if (__WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["a" /* isUndefined */](value))
        return "undefined";
    if (value == null)
        return "null";
    if (__WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["b" /* isString */](value)) {
        var str = value.toString();
        if (str.length > maxValueStringLength) {
            str = str.substring(0, maxValueStringLength - 3) + '...';
        }
        return "'" + str + "'";
    }
    if (__WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["c" /* isNumber */](value) || __WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["d" /* isBoolean */](value))
        return value.toString();
    if (__WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["e" /* isFunction */](value)) {
        var functionName = __WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["f" /* getTypeName */](value);
        var str = 'function';
        if (functionName) {
            str = str + " " + functionName;
        }
        return str;
    }
    return "object " + __WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["f" /* getTypeName */](value);
}
function stringifyArgs(args) {
    if (args == null)
        return '';
    return args.map(function (v) { return stringifyValue(v); }).join(', ');
}
function Trace(logLevel, errorLogLevel) {
    if (logLevel === void 0) { logLevel = __WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Trace; }
    if (errorLogLevel === void 0) { errorLogLevel = __WEBPACK_IMPORTED_MODULE_0__LogLevel__["a" /* LogLevel */].Error; }
    return function (target, propertyKey, descriptor) {
        if ((__WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* logger */].enabledFor(logLevel) || __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* logger */].enabledFor(errorLogLevel)) && __WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["e" /* isFunction */](descriptor.value)) {
            var oldFunc_1 = descriptor.value;
            descriptor.value = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var functionString = __WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["f" /* getTypeName */](this) + "." + propertyKey + "(" + stringifyArgs(args) + ")";
                __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* logger */].log(logLevel, "Executing " + functionString, {
                    this: this,
                    args: args
                });
                var result;
                try {
                    result = oldFunc_1.apply(this, args);
                }
                catch (e) {
                    __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* logger */].log(errorLogLevel, "Failed " + functionString, {
                        this: this,
                        args: args,
                        exception: e
                    });
                    throw e;
                }
                if (!__WEBPACK_IMPORTED_MODULE_2__misc_typeUtils__["a" /* isUndefined */](result)) {
                    Promise.resolve(result).then(function (r) {
                        __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* logger */].log(logLevel, "Executed " + functionString + " = " + stringifyValue(r), {
                            this: _this,
                            args: args,
                            result: r
                        });
                    }, function (r) {
                        __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* logger */].log(errorLogLevel, "Failed " + functionString, {
                            this: _this,
                            args: args,
                            reason: r
                        });
                        return Promise.reject(r);
                    });
                }
                return result;
            };
        }
    };
}
//# sourceMappingURL=Trace.js.map

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectKeysToLowerCase__ = __webpack_require__(15);
/* unused harmony reexport objectKeysToLowerCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interpolate__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__interpolate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__delay__ = __webpack_require__(53);
/* unused harmony reexport delay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parseUrl__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__parseUrl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typeUtils__ = __webpack_require__(5);
/* unused harmony namespace reexport */





//# sourceMappingURL=index.js.map

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectKeysToLowerCase;
function objectKeysToLowerCase(obj) {
    if (!obj)
        return obj;
    return Object.keys(obj)
        .reduce(function (acc, key) {
        acc[key.toLowerCase()] = obj[key];
        return acc;
    }, {});
}
//# sourceMappingURL=objectKeysToLowerCase.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(19).polyfill();


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultMessengerHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessengerContainerComponent__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xm_ui__ = __webpack_require__(1);



var DefaultMessengerHandler = /** @class */ (function () {
    function DefaultMessengerHandler() {
    }
    DefaultMessengerHandler.prototype.tryShowMessenger = function (hostElement, options, eventHandlers) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2_xm_ui__["a" /* Component */].mount(__WEBPACK_IMPORTED_MODULE_2_xm_ui__["a" /* Component */].render(__WEBPACK_IMPORTED_MODULE_1__MessengerContainerComponent__["a" /* MessengerContainerComponent */], __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({}, options)), hostElement, false)];
                    case 1:
                        _a.messenger = _b.sent();
                        this.messenger.on("hide", function () {
                            _this.messengerClosed();
                            eventHandlers.hide();
                        });
                        return [2 /*return*/, true];
                }
            });
        });
    };
    DefaultMessengerHandler.prototype.hideMessenger = function () {
        if (this.messenger != null) {
            this.messenger.data('component').hide();
        }
    };
    DefaultMessengerHandler.prototype.messengerClosed = function () {
        this.messenger = null;
    };
    return DefaultMessengerHandler;
}());



/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WindowVisibilityService; });
var WindowVisibilityService = /** @class */ (function () {
    function WindowVisibilityService() {
        var _a = this.getBrowserPrefix(), prefix = _a[0], hiddenPropertyName = _a[1];
        this.eventListeners = $.Callbacks();
        this.hiddenPropertyName = hiddenPropertyName;
        this.isVisible = this.getWindowVisibility();
        var visibilityEventName = this.getVisibilityEventName(prefix);
        $(document)
            .on(visibilityEventName, this.handleVisibilityChange.bind(this))
            .on('focus', this.handleVisibilityChange.bind(this, true));
        $(window)
            .on('focus', this.handleVisibilityChange.bind(this, true));
    }
    WindowVisibilityService.change = function (listener) {
        this.getInstance().eventListeners.add(listener);
    };
    WindowVisibilityService.unbind = function (listener) {
        this.getInstance().eventListeners.remove(listener);
    };
    WindowVisibilityService.getVisibilityStatus = function () {
        return this.getInstance().isVisible;
    };
    WindowVisibilityService.getInstance = function () {
        return WindowVisibilityService.instance || (WindowVisibilityService.instance = new WindowVisibilityService());
    };
    WindowVisibilityService.prototype.handleVisibilityChange = function (isVisible) {
        isVisible = typeof (isVisible) === 'boolean'
            ? isVisible
            : this.getWindowVisibility();
        if (this.isVisible === isVisible)
            return;
        this.isVisible = isVisible;
        this.eventListeners.fire(isVisible);
    };
    WindowVisibilityService.prototype.getBrowserPrefix = function () {
        var hiddenPropertyName;
        for (var _i = 0, _a = ['moz', 'ms', 'o', 'webkit']; _i < _a.length; _i++) {
            var prefix = _a[_i];
            if ((hiddenPropertyName = this.getHiddenPropertyName(prefix)) in document) {
                return [prefix, hiddenPropertyName];
            }
        }
        return ['', this.getHiddenPropertyName()];
    };
    WindowVisibilityService.prototype.getWindowVisibility = function () {
        return !document[this.hiddenPropertyName];
    };
    WindowVisibilityService.prototype.getHiddenPropertyName = function (prefix) {
        return prefix
            ? prefix + 'Hidden'
            : 'hidden';
    };
    WindowVisibilityService.prototype.getVisibilityEventName = function (prefix) {
        return prefix + "visibilitychange";
    };
    return WindowVisibilityService;
}());



/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(33)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = ".abc-messenger-container{width:370px!important;height:calc(100% - 20px)!important;min-height:250px!important;max-height:590px!important;position:fixed!important;z-index:2147483000!important;box-shadow:0 10px 30px rgba(0,0,0,.19),0 6px 10px rgba(0,0,0,.23)!important;border-radius:2px!important;overflow:hidden!important;opacity:0!important;-ms-transform:scale(.8)!important;transform:scale(.8)!important;transition:opacity .3s,transform .3s}.abc-messenger-visible{opacity:1!important;-ms-transform:scale(1)!important;transform:scale(1)!important}.abc-messenger-popup-top-left{left:20px!important;right:auto!important;top:20px!important;bottom:auto!important}.abc-messenger-popup-top-right{left:auto!important;right:20px!important;top:20px!important;bottom:auto!important}.abc-messenger-popup-center{width:480px!important;margin-left:-240px!important;margin-top:-295px!important;left:50%!important;top:50%!important}.abc-messenger-popup-bottom-left{left:20px!important;right:auto!important;top:auto!important;bottom:20px!important}.abc-messenger-popup-bottom-right{left:auto!important;right:20px!important;top:auto!important;bottom:20px!important}.abc-messenger-container iframe{width:100%!important;height:100%!important;border:0!important}@media (max-height:812px){.abc-messenger-container{margin-top:0!important;top:0!important;bottom:0!important}.abc-messenger-popup-top-left,.abc-messenger-popup-top-right{top:0!important;bottom:auto!important}.abc-messenger-popup-center{top:50%!important;bottom:auto!important;-ms-transform:translateY(-50%) scale(1)!important;transform:translateY(-50%) scale(1)!important}.abc-messenger-popup-bottom-left,.abc-messenger-popup-bottom-right{top:auto!important;bottom:0!important}}@media (max-width:479px){.abc-messenger-container{width:100%!important;height:100%!important;margin-left:0!important;margin-top:0!important;max-height:none!important;left:0!important;right:0!important;box-shadow:none;border-radius:0!important}}"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "*,:after,:before{box-sizing:border-box}body,button{font-family:Roboto,San Francisco,Helvetica Neue,Segoe UI,Arial;font-size:16px;color:#333}h1{font-size:56px}h2{font-size:45px}h3{font-size:34px}h4{font-size:24px}h5{font-size:20px}h6{font-size:16px}figure,h1,h2,h3,h4,h5,h6,iframe,ol,p,ul,video{margin:16px 0}figure:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,iframe:first-child,ol:first-child,p:first-child,ul:first-child,video:first-child{margin-top:0}figure:last-child,h1:last-child,h2:last-child,h3:last-child,h4:last-child,h5:last-child,h6:last-child,iframe:last-child,ol:last-child,p:last-child,ul:last-child,video:last-child{margin-bottom:0}figure{text-align:center}figcaption{font-size:14px;color:gray}img{max-width:100%;height:auto;border:0}a{color:#2196f3;text-decoration:underline}.btn,button{display:inline-block;margin:0;padding:8px 16px;line-height:1;color:#fff;font-size:16px;text-decoration:none;background:#2196f3;border:0;cursor:pointer}.btn-wide{width:100%}.btn-large{font-size:24px;padding:12px 24px}body{height:100%;margin:0;overflow:hidden}.container{position:absolute;left:0;top:0;right:0;bottom:0;background:#fff}.btn-close{padding:16px;position:absolute;top:8px;right:8px;z-index:110;line-height:1;font-size:24px;color:#fff;text-decoration:none;background:transparent;border:0;box-shadow:none;outline:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.container-form .btn-close{padding:16px 16px 8px 8px;top:0;right:0;color:#333}.author{display:table;width:100%;height:72px;position:absolute;left:0;top:0;z-index:100;background:#2196f3;box-shadow:0 1px 6px rgba(0,0,0,.12),0 1px 4px rgba(0,0,0,.12)}.author-avatar{display:table-cell;width:58px;padding:8px 0 8px 16px;vertical-align:middle}.author-avatar img{display:block;width:40px;height:40px;border-radius:50%}.author-name{display:table-cell;padding:20px 16px;color:#fff;font-size:18px;vertical-align:middle}.content{width:calc(100% - 32px);padding:16px;position:absolute;left:0;right:0;top:72px;bottom:54px;z-index:10;line-height:1.5;overflow-y:scroll;background:#fafafa;border:0;box-sizing:content-box}.container-form .content{top:0;overflow-y:auto}.content-without-reply{bottom:0}.composer{height:54px;min-height:54px;max-height:200px;position:absolute;left:0;right:0;bottom:0;border-top:1px solid #ddd}.message-box,.message-shadow{width:100%;margin:0;padding:16px 54px 16px 16px;line-height:1.2;color:#333;font-size:15px;font-family:Roboto,San Francisco,Helvetica Neue,Segoe UI,Arial;background:#fff;border:0;border-bottom-left-radius:2px;border-bottom-right-radius:2px;outline:0;transition:background .2s ease,box-shadow .2s ease;white-space:pre;white-space:pre-wrap;word-wrap:break-word;overflow:auto}.message-box{height:100%;position:absolute;bottom:0;left:0;resize:none}.message-shadow{visibility:hidden}.send-button{display:inline-block;width:44px;height:48px;padding:12px 12px 12px 8px;position:absolute;bottom:4px;right:12px;cursor:pointer;fill:currentColor}.send-button:hover{fill:#2196f3}.send-button.disabled{opacity:.3;cursor:default}.send-button.disabled:hover{fill:currentColor}.spinner{margin:8px auto}.success{color:#4caf50}.fail{color:#f44336}"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = ".spinner{width:50px;height:40px;text-align:center;font-size:10px}.spinner-rect{display:inline-block;height:100%;width:6px;margin:0 3px 0 0;background-color:gray;animation:a 1.2s infinite ease-in-out}.spinner-rect2{animation-delay:-1.1s}.spinner-rect3{animation-delay:-1s}.spinner-rect4{animation-delay:-.9s}.spinner-rect5{animation-delay:-.8s}@keyframes a{0%,40%,to{transform:scaleY(.4)}20%{transform:scaleY(1)}}"

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessengerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xm_ui__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessengerReplyComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_Validator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_PluginRepository__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_registerError__ = __webpack_require__(6);






var MessengerComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](MessengerComponent, _super);
    function MessengerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessengerComponent.prototype.render = function (childNodes) {
        var authorComponent = this.hasAuthor()
            ? (__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("header", { class: "author" },
                __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "author-avatar" },
                    __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("img", { src: this.options.response.Author.ImageUrl })),
                __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "author-name" }, this.options.response.Author.Name)))
            : null;
        var replyComponent = this.canBeReplied()
            ? __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render(__WEBPACK_IMPORTED_MODULE_2__MessengerReplyComponent__["a" /* MessengerReplyComponent */], __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({}, this.options.reply))
            : null;
        return (__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("main", { class: this.cls("container", "container-" + (this.options.response.Type || "message")) },
            this.renderStyles(),
            __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("button", { class: "btn-close", "data-action": "hide" }, "\u2715"),
            authorComponent,
            __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("section", { class: this.cls("content", !replyComponent ? "content-without-reply" : "") }, this.getContent()),
            replyComponent));
    };
    MessengerComponent.prototype.onMount = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPlugins()];
                    case 1:
                        _a.sent();
                        this.parentComponent.ready(function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](_this, void 0, void 0, function () {
                            var beep;
                            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.afterContentChanged()];
                                    case 1:
                                        _a.sent();
                                        if (this.soundsDisabled())
                                            return [2 /*return*/];
                                        beep = document.createElement("audio");
                                        if (beep.canPlayType && beep.canPlayType(this.options.soundFormat)) {
                                            beep.src = this.options.sound;
                                            beep.play();
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MessengerComponent.prototype.extendOptions = function (extendedOptions) {
        _super.prototype.extendOptions.call(this, extendedOptions);
        if (this.options.reply) {
            this.options.reply = $.extend({}, this.options.reply, {
                key: this.options.response.LabelName,
                attributes: {
                    Template: this.options.response.TemplateId
                }
            });
        }
    };
    MessengerComponent.prototype.getDefaultOptions = function () {
        return $.extend(_super.prototype.getDefaultOptions.call(this), {
            data: {},
            sound: "https://cdn.millionlakes.com/sounds/flop.mp3",
            soundFormat: "audio/mp3",
            fitToContent: true,
            errorText: 'An error occurred. Please try again later',
            pluginsDisabled: true
        });
    };
    MessengerComponent.prototype.getEventTarget = function () {
        return this.parentComponent.getHostElement();
    };
    MessengerComponent.prototype.renderStyles = function () {
        if (!this.options.response.Styles)
            return '';
        return (__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("style", null, this.options.response.Styles));
    };
    MessengerComponent.prototype.afterContentChanged = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var height;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.options.fitToContent) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.calculateMessengerHeight()];
                    case 1:
                        height = _a.sent();
                        this.fireEvent("resized", height);
                        return [3 /*break*/, 3];
                    case 2:
                        this.fireEvent("resized");
                        _a.label = 3;
                    case 3:
                        this.updateContentAnchors();
                        return [2 /*return*/];
                }
            });
        });
    };
    MessengerComponent.prototype.getContent = function () {
        if (!this.options.data)
            return this.options.response.Content;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["f" /* interpolate */])(this.options.response.Content, this.options.data);
    };
    MessengerComponent.prototype.calculateMessengerHeight = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var dummy, container;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                dummy = this.contentContainer
                    .clone();
                container = this.contentContainer.parent();
                this.prepareHostElementForSizeCalculation(dummy, container);
                container.append(dummy);
                return [2 /*return*/, new Promise(function (resolve) {
                        var images = dummy.find("img");
                        var loadedCount = 0;
                        var calculate = function () {
                            var contentHeight = dummy.outerHeight();
                            dummy.remove();
                            return contentHeight
                                + _this.authorComponent.outerHeight()
                                + _this.composerComponent.outerHeight();
                        };
                        if (images.length > 0) {
                            images.on("load error", function () {
                                if (++loadedCount < images.length)
                                    return;
                                resolve(calculate());
                            });
                        }
                        else {
                            resolve(calculate());
                        }
                    })];
            });
        });
    };
    MessengerComponent.prototype.canBeReplied = function () {
        return this.options.response.Type === 'message'
            && this.options.response.ShowReply
            && this.options.reply
            && this.options.reply.api
            && this.options.reply.api.baseAddress
            && this.options.reply.user
            && this.options.reply.user.id;
    };
    MessengerComponent.prototype.hasAuthor = function () {
        return this.options.response && this.options.response.Author;
    };
    MessengerComponent.prototype.soundsDisabled = function () {
        return !this.options.response || !this.options.response.SoundEffect || !this.options.soundFormat || !this.options.sound;
    };
    MessengerComponent.prototype.loadPlugins = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _i, _a, pluginName, plugin, e_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.options.pluginsDisabled || !this.options.response || !this.options.response.Scripts)
                            return [2 /*return*/];
                        _i = 0, _a = this.options.response.Scripts;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 7];
                        pluginName = _a[_i];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4__plugins_PluginRepository__["a" /* PluginRepository */].loadPlugin(pluginName)];
                    case 3:
                        plugin = _b.sent();
                        return [4 /*yield*/, plugin.plug(this)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_registerError__["a" /* registerError */])(e_1);
                        return [3 /*break*/, 6];
                    case 6:
                        _i++;
                        return [3 /*break*/, 1];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MessengerComponent.prototype.formSubmitted = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var apiResponse;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        apiResponse = this.options.response;
                        if (apiResponse.SubmitRedirectUrl) {
                            window.top.location.href = apiResponse.SubmitRedirectUrl;
                            return [2 /*return*/];
                        }
                        if (!apiResponse.SubmitResponse) return [3 /*break*/, 2];
                        this.contentContainer.html(apiResponse.SubmitResponse);
                        return [4 /*yield*/, this.afterContentChanged()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    MessengerComponent.prototype.updateContentAnchors = function () {
        this.getHostElement().find('a:not([target])').each(function (i, anchor) {
            $(anchor).attr('target', '_top');
        });
    };
    MessengerComponent.prototype.onCloseButtonClick = function () {
        this.fireEvent('hide');
    };
    MessengerComponent.prototype.onInternalClick = function (e) {
        this.fireEvent('internal_click', e);
    };
    MessengerComponent.prototype.onComposerResized = function (e, composerHeight) {
        this.contentContainer.css('bottom', composerHeight);
    };
    MessengerComponent.prototype.formSubmit = function (e) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var form, previousValidationResult, validator, validationResult, http, apiUrl, data, e_2;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        if (this.loading)
                            return [2 /*return*/];
                        form = $(e.target).closest('form');
                        previousValidationResult = form.data('validationResult');
                        if (previousValidationResult)
                            previousValidationResult.clear(form);
                        form.find('.global-error').remove();
                        validator = new __WEBPACK_IMPORTED_MODULE_3__validation_Validator__["a" /* Validator */](this.options.response.ValidationRules);
                        validationResult = validator.validate(form);
                        if (!!validationResult.isValid) return [3 /*break*/, 2];
                        validationResult.mark(form);
                        return [4 /*yield*/, this.afterContentChanged()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        this.loading = true;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 6, , 8]);
                        http = new __WEBPACK_IMPORTED_MODULE_1_xm_ui__["g" /* HttpClient */]();
                        apiUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["f" /* interpolate */])(this.options.apiUrl, {
                            action: 'PostTemplateFormData'
                        });
                        data = $.extend({}, this.options.initParams, {
                            templateId: this.options.response.TemplateId,
                            properties: form.serializeArray().reduce(function (properties, field) {
                                properties[field.name] = field.value;
                                return properties;
                            }, {})
                        });
                        return [4 /*yield*/, http.post(apiUrl, data)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.formSubmitted()];
                    case 5:
                        _a.sent();
                        this.loading = false;
                        return [3 /*break*/, 8];
                    case 6:
                        e_2 = _a.sent();
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_registerError__["a" /* registerError */])(e_2);
                        $('<p></p>', {
                            "class": "global-error error",
                            text: this.options.errorText
                        }).prependTo(form);
                        return [4 /*yield*/, this.afterContentChanged()];
                    case 7:
                        _a.sent();
                        this.loading = false;
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["h" /* Ref */])('.author')
    ], MessengerComponent.prototype, "authorComponent", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["h" /* Ref */])('.content')
    ], MessengerComponent.prototype, "contentContainer", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["h" /* Ref */])('.composer')
    ], MessengerComponent.prototype, "composerComponent", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["i" /* LogExceptions */])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["d" /* Trace */])(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["e" /* LogLevel */].Info)
    ], MessengerComponent.prototype, "onMount", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["j" /* PreventDefault */])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("click", "[data-action='hide']")
    ], MessengerComponent.prototype, "onCloseButtonClick", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("click", "a,button")
    ], MessengerComponent.prototype, "onInternalClick", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("resized", ".composer")
    ], MessengerComponent.prototype, "onComposerResized", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("submit", "form"),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("click", "[data-action='submit']"),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["d" /* Trace */])(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["e" /* LogLevel */].Info)
    ], MessengerComponent.prototype, "formSubmit", null);
    return MessengerComponent;
}(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */]));



/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessengerContainerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xm_ui__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessengerComponent__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_messenger_container_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_messenger_container_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_messenger_container_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_messenger_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_messenger_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_messenger_css__);





var MessengerContainerComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](MessengerContainerComponent, _super);
    function MessengerContainerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessengerContainerComponent.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var options, messengerStyles, _a, DisplayType, containerClass;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_b) {
                options = this.options;
                messengerStyles = options.messengerStyles;
                _a = this.options.response.DisplayType, DisplayType = _a === void 0 ? "popup-bottom-right" : _a;
                containerClass = this.options.classPrefix + "container " + this.options.classPrefix + DisplayType.toLowerCase().split(" ").join("-");
                return [2 /*return*/, (__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: this.options.classPrefix + "event-target" },
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("style", null, __WEBPACK_IMPORTED_MODULE_3__assets_messenger_container_css__),
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: containerClass },
                            __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["b" /* IsolatedScope */], { class: this.options.classPrefix + "scope", isolatedStyles: messengerStyles },
                                __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render(__WEBPACK_IMPORTED_MODULE_2__MessengerComponent__["a" /* MessengerComponent */], __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({}, options))))))];
            });
        });
    };
    MessengerContainerComponent.prototype.hide = function () {
        this.destroy();
        this.getHostElement().remove();
    };
    MessengerContainerComponent.prototype.getDefaultOptions = function () {
        return $.extend(_super.prototype.getDefaultOptions.call(this), {
            messengerStyles: __WEBPACK_IMPORTED_MODULE_4__assets_messenger_css__,
            classPrefix: "abc-messenger-",
            minScreenHeight: 768
        });
    };
    MessengerContainerComponent.prototype.getEventTarget = function () {
        return this.eventTarget;
    };
    MessengerContainerComponent.prototype.onMount = function () {
        this.eventTarget = this.getHostElement()
            .find("." + this.options.classPrefix + "container");
        this.fireEvent("mount");
    };
    MessengerContainerComponent.prototype.onMessengerResized = function (e, owner, messengerHeight) {
        if (messengerHeight && screen.height >= this.options.minScreenHeight) {
            var cssMaxHeight = parseInt(this.getEventTarget().css('max-height')) || this.getEventTarget().outerHeight();
            var cssMinHeight = parseInt(this.getEventTarget().css('min-height')) || this.getEventTarget().height();
            if (messengerHeight < cssMinHeight)
                messengerHeight = cssMinHeight;
            if (messengerHeight < cssMaxHeight) {
                this.getEventTarget().attr("style", "max-height: " + messengerHeight + "px !important");
            }
        }
        this.eventTarget.addClass(this.options.classPrefix + "visible");
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("hide", "[isolated-scope]"),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["d" /* Trace */])(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["e" /* LogLevel */].Info)
    ], MessengerContainerComponent.prototype, "hide", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["d" /* Trace */])(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["e" /* LogLevel */].Info)
    ], MessengerContainerComponent.prototype, "onMount", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("resized", "[isolated-scope]"),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["d" /* Trace */])(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["e" /* LogLevel */].Info)
    ], MessengerContainerComponent.prototype, "onMessengerResized", null);
    return MessengerContainerComponent;
}(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */]));



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessengerReplyComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xm_ui__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpinnerComponent__ = __webpack_require__(27);



var MessengerReplyComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](MessengerReplyComponent, _super);
    function MessengerReplyComponent(options) {
        var _this = _super.call(this, options) || this;
        _this.http = new __WEBPACK_IMPORTED_MODULE_1_xm_ui__["g" /* HttpClient */]();
        return _this;
    }
    MessengerReplyComponent.prototype.render = function (childNodes) {
        return (__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("footer", { class: "composer" },
            __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("pre", { class: "message-shadow" }),
            __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("textarea", { class: "message-box", placeholder: this.options.placeholder }),
            __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("span", { class: "send-button disabled" }, "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n                        <path d=\"M2.01 21L23 12 2.01 3 2 10l15 2-15 2z\"/>\n                    </svg>")));
    };
    MessengerReplyComponent.prototype.getDefaultOptions = function () {
        return $.extend(_super.prototype.getDefaultOptions.call(this), {
            api: {},
            user: {},
            minHeight: 54,
            maxHeight: 200,
            minTextLength: 3,
            placeholder: "Write a reply...",
            messageSent: "Thank you for your reply.",
            errorOccurred: "Some error occurred."
        });
    };
    MessengerReplyComponent.prototype.onMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.messageBox.focus().blur();
        });
    };
    MessengerReplyComponent.prototype.post = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var message, spinner, spinnerHtml, response, e_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = this.messageBox.val();
                        if (!message || message.length < this.options.minTextLength)
                            return [2 /*return*/];
                        this.messageBox.val("");
                        this.onTextChanged();
                        spinner = new __WEBPACK_IMPORTED_MODULE_2__SpinnerComponent__["a" /* SpinnerComponent */]();
                        return [4 /*yield*/, spinner.build([])];
                    case 1:
                        spinnerHtml = _a.sent();
                        this.getHostElement().empty().append(spinnerHtml);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.http.post(this.options.api.baseAddress + "/Comment", {
                                apiKey: this.options.api.key,
                                key: "abc-messenger/" + this.options.key,
                                userId: this.options.user.id,
                                userName: this.options.user.name,
                                userImage: this.options.user.image,
                                text: message,
                                contentId: this.options.key,
                                language: this.options.api.language,
                                attributes: this.options.attributes
                            })];
                    case 3:
                        response = _a.sent();
                        this.getHostElement().html("<p class=\"message-box success\">" + this.options.messageSent + "</p>");
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.getHostElement().html("<p class=\"message-box fail\">" + this.options.errorOccurred + "</p>");
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MessengerReplyComponent.prototype.onTextChanged = function () {
        var oldHeight = this.getHostElement().outerHeight();
        var message = this.messageBox.val();
        this.messageShadow.html(message + "<br>");
        var newHeight = this.messageShadow.outerHeight();
        if (newHeight > this.options.maxHeight)
            newHeight = this.options.maxHeight;
        if (newHeight < this.options.minHeight)
            newHeight = this.options.minHeight;
        if (oldHeight !== newHeight) {
            this.getHostElement()
                .trigger('resized', [newHeight])
                .height(newHeight);
        }
        this.sendButton.toggleClass("disabled", message.length < this.options.minTextLength);
    };
    MessengerReplyComponent.prototype.onSendButtonClick = function () {
        this.post();
    };
    MessengerReplyComponent.prototype.onCtrlEnter = function (event) {
        if (event.ctrlKey && event.keyCode == 13) {
            this.post();
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["h" /* Ref */])('.message-box')
    ], MessengerReplyComponent.prototype, "messageBox", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["h" /* Ref */])('.message-shadow')
    ], MessengerReplyComponent.prototype, "messageShadow", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["h" /* Ref */])('.send-button')
    ], MessengerReplyComponent.prototype, "sendButton", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["d" /* Trace */])(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["e" /* LogLevel */].Info),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["i" /* LogExceptions */])()
    ], MessengerReplyComponent.prototype, "post", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("keyup paste", ".message-box")
    ], MessengerReplyComponent.prototype, "onTextChanged", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["j" /* PreventDefault */])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("click", ".send-button")
    ], MessengerReplyComponent.prototype, "onSendButtonClick", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["c" /* Bind */])("keydown", ".message-box")
    ], MessengerReplyComponent.prototype, "onCtrlEnter", null);
    return MessengerReplyComponent;
}(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */]));



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xm_ui__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_spinner_css__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_spinner_css__);



var SpinnerComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](SpinnerComponent, _super);
    function SpinnerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerComponent.prototype.render = function (childNodes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                return [2 /*return*/, (__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "spinner" },
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("style", null, this.options.styles),
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "spinner-rect spinner-rect1" }),
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "spinner-rect spinner-rect2" }),
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "spinner-rect spinner-rect3" }),
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "spinner-rect spinner-rect4" }),
                        __WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */].render("div", { class: "spinner-rect spinner-rect5" })))];
            });
        });
    };
    SpinnerComponent.prototype.getDefaultOptions = function () {
        return $.extend(_super.prototype.getDefaultOptions.call(this), {
            styles: __WEBPACK_IMPORTED_MODULE_2__assets_spinner_css__
        });
    };
    return SpinnerComponent;
}(__WEBPACK_IMPORTED_MODULE_1_xm_ui__["a" /* Component */]));



/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_WindowVisibilityService__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_registerError__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DefaultMessengerHandler__ = __webpack_require__(17);





var MessengerApi = /** @class */ (function () {
    function MessengerApi(options) {
        this.options = $.extend(true, this.getDefaultOptions(), options);
        this.hostElement = $('<div>').appendTo(document.body);
        this.currentMessengerHandler = null;
        this.defaultMessengerHandler = new __WEBPACK_IMPORTED_MODULE_4__components_DefaultMessengerHandler__["a" /* DefaultMessengerHandler */]();
        this.messengerHandlerMap = Object.create(null);
    }
    MessengerApi.prototype.connect = function () {
        var _this = this;
        this.socketConnection = $.hubConnection(this.options.socketHubUrl, { useDefaultPath: false });
        this.hubProxy = this.socketConnection.createHubProxy(this.options.hubName);
        var isVisible = false;
        this.socketConnection.error(function (e) {
            if (e.source === 'TimeoutException')
                return;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_registerError__["a" /* registerError */])(e);
        });
        this.socketConnection.connectionSlow(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_registerError__["a" /* registerError */])('connectionSlow');
        });
        this.socketConnection.stateChanged(function (state) {
            _this.isConnected = state.newState === $.signalR.connectionState.connected;
        });
        this.socketConnection.disconnected(function () {
            setTimeout(function () {
                _this.wsStart();
            }, _this.options.socketReconnectionTimeout);
        });
        this.hubProxy.on('getActivityStatus', function () {
            _this.wsInvoke('sendPageActivityStatus', isVisible, (new Date()).getTime());
        });
        this.hubProxy.on('getWindow', this.onGetWindow.bind(this));
        this.hubProxy.on('closeWindow', function () {
            if (_this.currentMessengerHandler != null) {
                _this.currentMessengerHandler.hideMessenger();
            }
        });
        this.hubProxy.on('reconnect', function () {
            _this.socketConnection.stop();
            _this.wsStart();
        });
        __WEBPACK_IMPORTED_MODULE_2__utils_WindowVisibilityService__["a" /* WindowVisibilityService */].change(function (isVisible) {
            if (!_this.isConnected)
                return;
            if (isVisible) {
                _this.hubProxy.invoke('onPageActivate', (new Date()).getTime());
            }
            else {
                _this.hubProxy.invoke('onPageDeactivate', (new Date()).getTime());
            }
        });
        this.wsStart();
    };
    MessengerApi.prototype.listen = function (event, listener) {
        this.hostElement.on(event, listener);
    };
    MessengerApi.prototype.config = function (option, value) {
        if (typeof (option) === "string") {
            this.options[option] = value;
        }
        else {
            this.options = $.extend(true, this.options, option);
        }
    };
    MessengerApi.prototype.set = function (key, value) {
        this.options.data = this.options.data || {};
        this.options.data[key] = value;
    };
    MessengerApi.prototype.registerHandler = function (displayType, handler) {
        this.messengerHandlerMap[displayType] = handler;
    };
    MessengerApi.prototype.wsStart = function () {
        var _this = this;
        this.socketConnection.start()
            .done(function () {
            var params = $.extend({
                url: _this.getPageUrl(),
                sentWindow: _this.shownWindowId,
                notActive: !__WEBPACK_IMPORTED_MODULE_2__utils_WindowVisibilityService__["a" /* WindowVisibilityService */].getVisibilityStatus()
            }, _this.options.initParams);
            _this.wsInvoke('onConnectionInit', params);
            _this.hostElement.trigger('connect', _this);
        });
    };
    MessengerApi.prototype.wsInvoke = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.isConnected)
            return;
        return new Promise(function (resolve, reject) {
            var _a;
            (_a = _this.hubProxy).invoke.apply(_a, [methodName].concat(args)).then(function (response) { return resolve(response); })
                .fail(function (e) {
                reject(e);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_registerError__["a" /* registerError */])(e, methodName);
            });
        });
    };
    MessengerApi.prototype.onGetWindow = function (response) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var optionsWithApiResponse, messengerIsShown;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shownWindowId) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_registerError__["a" /* registerError */])('Window already shown');
                            return [2 /*return*/];
                        }
                        this.shownWindowId = response.LabelId;
                        this.currentMessengerHandler = this.messengerHandlerMap[response.DisplayType] || this.defaultMessengerHandler;
                        optionsWithApiResponse = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({}, this.options, { response: response });
                        this.wsInvoke('windowSent', response.Uid);
                        return [4 /*yield*/, new Promise(function (resolve) {
                                setTimeout(resolve, response.Delay || 0);
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.currentMessengerHandler.tryShowMessenger(this.hostElement, optionsWithApiResponse, {
                                hide: function () { return _this.wsInvoke('windowClosed', _this.shownWindowId); }
                            })];
                    case 2:
                        messengerIsShown = _a.sent();
                        if (messengerIsShown) {
                            this.wsInvoke('windowShown', this.shownWindowId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MessengerApi.prototype.getPageUrl = function () {
        return document.location.href;
    };
    MessengerApi.prototype.getPageLoadId = function () {
        return window._abc_plid_ || (window._abc_plid_ = (new Date()).getTime());
    };
    MessengerApi.prototype.getDefaultOptions = function () {
        return $.extend({}, {
            apiUrl: '//l.millionlakes.com/api/UserLabel/{action}',
            socketHubUrl: '//l.millionlakes.com/signalr',
            hubName: 'pageHub',
            data: {
                pageUrl: this.getPageUrl()
            },
            initParams: {
                pageLoad: this.getPageLoadId()
            },
            socketReconnectionTimeout: 2000
        });
    };
    return MessengerApi;
}());
var api = new MessengerApi(window._abc_msg_options_);
var queueName = window._abc_msg_queue_ || 'abc_msg';
(function (publicApi, slice) {
    var queue = publicApi.q || [];
    for (var i = 0; i < queue.length; i++) {
        var args = queue[i];
        if (args && args.length && args[0] in api) {
            api[args[0]].apply(api, slice.call(args, 1));
        }
    }
    if (!publicApi.loaded) {
        publicApi = window[queueName] = function (action) {
            if (action in api) {
                api[action].apply(api, slice.call(arguments, 1));
            }
        };
        publicApi.loaded = true;
    }
})(window[queueName] || {}, Array.prototype.slice);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PluginRepository; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);

var PluginRepository = /** @class */ (function () {
    function PluginRepository() {
    }
    PluginRepository.loadPlugin = function (pluginName) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _a, module;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = pluginName;
                        switch (_a) {
                            case "facebook": return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 56))];
                    case 2:
                        module = _b.sent();
                        return [2 /*return*/, new module.FacebookPlugin()];
                    case 3: throw new Error("Plugin " + pluginName + " is not supported");
                }
            });
        });
    };
    ;
    return PluginRepository;
}());



/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequiredValidator; });
var RequiredValidator = /** @class */ (function () {
    function RequiredValidator() {
        this.defaultErrorMessage = 'Field is required';
    }
    RequiredValidator.prototype.isValid = function (fieldValue) {
        return !!fieldValue;
    };
    return RequiredValidator;
}());



/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationResult; });
var ValidationResult = /** @class */ (function () {
    function ValidationResult(options) {
        if (options === void 0) { options = {}; }
        this.isValid = true;
        this.errors = [];
        this.options = $.extend(this.getDefaultOptions(), options);
    }
    ValidationResult.prototype.push = function (validationError) {
        this.isValid = false;
        this.errors.push(validationError);
    };
    ValidationResult.prototype.mark = function (form) {
        var _this = this;
        form.data('validationResult', this);
        var _loop_1 = function (error) {
            error.formField
                .on('change.validator', function () { return _this.revalidate(error); })
                .closest(this_1.options.fieldContainerSelector)
                .addClass(this_1.options.errorClassName);
            $('<label>', {
                "class": this_1.options.errorMessageClassName,
                text: error.message
            }).insertAfter(error.formField);
        };
        var this_1 = this;
        for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
            var error = _a[_i];
            _loop_1(error);
        }
    };
    ValidationResult.prototype.clear = function (form) {
        form.removeData('validationResult');
        for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
            var error = _a[_i];
            this.clearField(error.formField);
        }
    };
    ValidationResult.prototype.clearField = function (formField) {
        formField
            .off('change.validator')
            .closest(this.options.fieldContainerSelector).removeClass(this.options.errorClassName)
            .find("." + this.options.errorMessageClassName).remove();
    };
    ValidationResult.prototype.revalidate = function (validationError) {
        if (!validationError.validator.isValid(validationError.formField))
            return;
        this.clearField(validationError.formField);
    };
    ValidationResult.prototype.getDefaultOptions = function () {
        return {
            fieldContainerSelector: '.field-group',
            errorClassName: 'error',
            errorMessageClassName: 'field-message'
        };
    };
    return ValidationResult;
}());



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Validator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RequiredValidator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidationResult__ = __webpack_require__(31);


var Validator = /** @class */ (function () {
    function Validator(validationRules) {
        this.validationRules = validationRules;
        this.availableValidators = {
            required: new __WEBPACK_IMPORTED_MODULE_0__RequiredValidator__["a" /* RequiredValidator */]()
        };
    }
    Validator.prototype.validate = function (form) {
        var validationResult = new __WEBPACK_IMPORTED_MODULE_1__ValidationResult__["a" /* ValidationResult */]();
        if (!this.validationRules)
            return validationResult;
        var validationFields = Object.keys(this.validationRules);
        for (var _i = 0, validationFields_1 = validationFields; _i < validationFields_1.length; _i++) {
            var fieldName = validationFields_1[_i];
            var fieldValidationRules = this.validationRules[fieldName];
            var validatorNames = Object.keys(fieldValidationRules).filter(function (validatorName) { return validatorName !== 'messages'; });
            for (var _a = 0, validatorNames_1 = validatorNames; _a < validatorNames_1.length; _a++) {
                var validatorName = validatorNames_1[_a];
                var validator = this.availableValidators[validatorName];
                var formField = form.find("[name=\"" + fieldName + "\"]");
                if (!validator || validator.isValid(formField.val()))
                    continue;
                validationResult.push({
                    name: fieldName,
                    formField: formField,
                    validator: validator,
                    message: fieldValidationRules
                        && fieldValidationRules.messages
                        && fieldValidationRules.messages[validatorName]
                        || validator.defaultErrorMessage
                });
            }
        }
        return validationResult;
    };
    return Validator;
}());



/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AsyncScope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Component__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseComponent__ = __webpack_require__(2);



var AsyncScope = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](AsyncScope, _super);
    function AsyncScope() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsyncScope.prototype.getDefaultOptions = function () {
        return {
            placeholder: "Loading..."
        };
    };
    AsyncScope.prototype.render = function (childNodes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _a, placeholder, options;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_b) {
                Promise.all(Array.prototype.concat.apply([], childNodes))
                    .then(function (childNodesContent) {
                    _this.getHostElement().replaceWith(childNodesContent);
                    __WEBPACK_IMPORTED_MODULE_1__Component__["a" /* Component */].mountRenderedComponents();
                });
                _a = this.options, placeholder = _a.placeholder, options = __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __rest */](_a, ["placeholder"]);
                return [2 /*return*/, $("<div>", __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({}, options, { html: placeholder }))];
            });
        });
    };
    return AsyncScope;
}(__WEBPACK_IMPORTED_MODULE_2__BaseComponent__["a" /* BaseComponent */]));

//# sourceMappingURL=AsyncScope.js.map

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntrinsicComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseComponent__ = __webpack_require__(2);


var IntrinsicComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](IntrinsicComponent, _super);
    function IntrinsicComponent(tagName, options) {
        var _this = _super.call(this, options) || this;
        _this.tagName = tagName;
        return _this;
    }
    IntrinsicComponent.prototype.render = function (childNodes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var childNodesContent, options;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(Array.prototype.concat.apply([], childNodes))];
                    case 1:
                        childNodesContent = _a.sent();
                        options = $.extend({}, this.options, { html: childNodesContent });
                        return [2 /*return*/, $("<" + this.tagName + ">", options)];
                }
            });
        });
    };
    return IntrinsicComponent;
}(__WEBPACK_IMPORTED_MODULE_1__BaseComponent__["a" /* BaseComponent */]));

//# sourceMappingURL=IntrinsicComponent.js.map

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IsolatedScope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseComponent__ = __webpack_require__(2);


var IsolatedScope = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */](IsolatedScope, _super);
    function IsolatedScope() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.readyCallbacks = $.Callbacks();
        return _this;
    }
    IsolatedScope.prototype.ready = function (callback) {
        if (this.readyCallbacks.fired()) {
            callback();
            return;
        }
        this.readyCallbacks.add(callback);
    };
    IsolatedScope.prototype.render = function (childNodes) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var _a, isolatedStyles, options, frame, _b;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.options, isolatedStyles = _a.isolatedStyles, options = __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __rest */](_a, ["isolatedStyles"]);
                        frame = $('<iframe>', $.extend(options, {
                            'isolated-scope': ''
                        }));
                        frame.on('load', function () { return _this.mountIsolatedContent(); });
                        _b = this;
                        return [4 /*yield*/, Promise.all(Array.prototype.concat.apply([], childNodes))];
                    case 1:
                        _b.childNodes = _c.sent();
                        this.setChildComponentsAncestor();
                        return [2 /*return*/, frame];
                }
            });
        });
    };
    IsolatedScope.prototype.getChildComponents = function () {
        return this.getHostElement()
            .contents()
            .find('[data-xmid]')
            .toArray()
            .map(function (elem) { return $(elem).data('component'); })
            .filter(function (component) { return component != null; });
    };
    IsolatedScope.prototype.mountIsolatedContent = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
            var html;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                html = $('<html>', {
                    html: (this.options.isolatedStyles ? ["<head><base target=\"_parent\"><style>" + this.options.isolatedStyles + "</style></head>"] : []).concat([
                        $('<body>', {
                            html: this.childNodes
                        })
                    ])
                });
                this.getHostElement()
                    .contents()
                    .find('html')
                    .replaceWith(html);
                this.readyCallbacks.fire();
                return [2 /*return*/];
            });
        });
    };
    IsolatedScope.prototype.setChildComponentsAncestor = function () {
        for (var i = 0; i < this.childNodes.length; i++) {
            this.childNodes[i].data('component').parentComponent = this;
        }
    };
    return IsolatedScope;
}(__WEBPACK_IMPORTED_MODULE_1__BaseComponent__["a" /* BaseComponent */]));

//# sourceMappingURL=IsolatedScope.js.map

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Component__ = __webpack_require__(7);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScope__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IsolatedScope__ = __webpack_require__(36);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__IsolatedScope__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Session */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemorySessionStorage__ = __webpack_require__(8);

var Session = /** @class */ (function () {
    function Session(category, sessionStorageFactory, component) {
        this.category = category;
        if (!sessionStorageFactory) {
            sessionStorageFactory = function (category) { return new __WEBPACK_IMPORTED_MODULE_0__MemorySessionStorage__["a" /* MemorySessionStorage */](category); };
        }
        Session.storage = Session.storage || sessionStorageFactory(this.category);
        if (component != null) {
            this.attach(component);
        }
    }
    Session.prototype.attach = function (component) {
        Session.callbacks[this.category] = Session.callbacks[this.category] || $.Callbacks();
        Session.callbacks[this.category].add(component.fireHandler.bind(component, 'change.session'));
    };
    Session.prototype.getAll = function () {
        return Session.storage.getAll();
    };
    Session.prototype.get = function (key) {
        return Session.storage.getItem(key);
    };
    Session.prototype.getStorage = function () {
        return Session.storage;
    };
    Session.prototype.set = function (key, value) {
        Session.storage.setItem(key, value);
        this.changed(key, value);
    };
    Session.prototype.remove = function (key) {
        Session.storage.removeItem(key);
        this.changed(key, null);
    };
    Session.prototype.changed = function (key, value) {
        Session.callbacks[this.category].fire(key, value);
    };
    Session.callbacks = {};
    return Session;
}());

//# sourceMappingURL=Session.js.map

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WebSessionStorage */
var WebSessionStorage = /** @class */ (function () {
    function WebSessionStorage(category, storage) {
        if (storage === void 0) { storage = sessionStorage; }
        this.category = category;
        this.storage = storage;
    }
    WebSessionStorage.prototype.getKey = function () {
        return this.category;
    };
    WebSessionStorage.prototype.clear = function () {
        var storageKey = this.getKey();
        this.storage.removeItem(storageKey);
    };
    WebSessionStorage.prototype.getAll = function () {
        var storageKey = this.getKey();
        var storage = this.storage.getItem(storageKey);
        if (!storage) {
            return {};
        }
        return JSON.parse(storage);
    };
    WebSessionStorage.prototype.getItem = function (key) {
        var storage = this.getAll();
        return storage[key];
    };
    WebSessionStorage.prototype.setItem = function (key, value) {
        var storageKey = this.getKey();
        var storage = this.getAll();
        storage[key] = value;
        this.storage.setItem(storageKey, JSON.stringify(storage));
    };
    WebSessionStorage.prototype.setRaw = function (state) {
        var storageKey = this.getKey();
        this.storage.setItem(storageKey, JSON.stringify(state));
    };
    WebSessionStorage.prototype.removeItem = function (key) {
        var storageKey = this.getKey();
        var storage = this.getAll();
        delete storage[key];
        this.storage.setItem(storageKey, JSON.stringify(storage));
    };
    return WebSessionStorage;
}());

//# sourceMappingURL=WebSessionStorage.js.map

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Session__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MemorySessionStorage__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WebSessionStorage__ = __webpack_require__(39);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Bind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_Metadata__ = __webpack_require__(4);

function Bind(eventName, selector) {
    return function (target, propertyKey, descriptor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__metadata_Metadata__["a" /* setMetadata */])(target, 'EventListener', {
            eventName: eventName,
            selector: selector,
            handler: propertyKey
        }, propertyKey);
    };
}
//# sourceMappingURL=Bind.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Observable */
function Observable(eventName, afterMethodEventName, propagate) {
    if (propagate === void 0) { propagate = true; }
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        var fireMethod = propagate ? "fireEvent" : "fireHandler";
        descriptor.value = function () {
            var methodArguments = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                methodArguments[_i] = arguments[_i];
            }
            var _a, _b;
            if (eventName || !afterMethodEventName)
                (_a = this[fireMethod]).call.apply(_a, [this, eventName || propertyKey].concat(methodArguments));
            var result = method.apply(this, methodArguments);
            if (afterMethodEventName)
                (_b = this[fireMethod]).call.apply(_b, [this, afterMethodEventName].concat(methodArguments));
            return result;
        };
    };
}
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PreventDefault;
function PreventDefault() {
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        descriptor.value = function () {
            if (arguments.length && arguments[0].preventDefault)
                arguments[0].preventDefault();
            return method.apply(this, Array.prototype.slice.call(arguments));
        };
    };
}
//# sourceMappingURL=PreventDefault.js.map

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Ref;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_Metadata__ = __webpack_require__(4);

function Ref(selector) {
    return function (target, propertyKey) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__metadata_Metadata__["a" /* setMetadata */])(target, 'ElementReference', {
            selector: selector,
            handler: propertyKey
        }, propertyKey);
    };
}
//# sourceMappingURL=Ref.js.map

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StopPropagation */
function StopPropagation() {
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        descriptor.value = function () {
            if (arguments.length && arguments[0].stopPropagation)
                arguments[0].stopPropagation();
            return method.apply(this, Array.prototype.slice.call(arguments));
        };
    };
}
//# sourceMappingURL=StopPropagation.js.map

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Bind__ = __webpack_require__(41);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Bind__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Ref__ = __webpack_require__(44);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Ref__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PreventDefault__ = __webpack_require__(43);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__PreventDefault__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StopPropagation__ = __webpack_require__(45);
/* unused harmony namespace reexport */





//# sourceMappingURL=index.js.map

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Exception__ = __webpack_require__(9);
/* unused harmony reexport Exception */

//# sourceMappingURL=index.js.map

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpException__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__xdr__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__xdr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__xdr__);




var HttpClient = /** @class */ (function () {
    function HttpClient(options) {
        this.options = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({}, this.getDefaultOptions(), { options: options });
    }
    HttpClient.prototype.getDefaultOptions = function () {
        return {
            retryCount: 3,
            retryTimeout: 1000
        };
    };
    HttpClient.prototype.send = function (url, settings) {
        var retryCount = this.options.retryCount;
        var timeout = this.options.retryTimeout;
        if (!settings)
            settings = {};
        return new Promise(function (resolve, reject) {
            $.ajax(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({ url: url, method: "GET", headers: { Accept: "application/json" }, dataType: "json", crossDomain: HttpClient.isCrossDomainRequest(url) }, settings, { success: resolve, error: function (xhr, textStatus, errorThrown) {
                    var _this = this;
                    if (--retryCount && (xhr.status !== 400 && xhr.status !== 404 && xhr.status !== 500)) {
                        setTimeout(function () { return jQuery.ajax(_this); }, timeout);
                    }
                    else {
                        reject(new __WEBPACK_IMPORTED_MODULE_1__HttpException__["a" /* HttpException */](xhr.status, textStatus, errorThrown));
                    }
                } }));
        });
    };
    HttpClient.prototype.get = function (url, parameters) {
        var settings = parameters
            ? { data: $.param(parameters) }
            : {};
        return this.send(url, settings);
    };
    HttpClient.prototype.post = function (url, parameters) {
        var settings = {
            method: "POST",
            processData: false,
            contentType: "application/json"
        };
        if (parameters)
            settings.data = JSON.stringify(parameters);
        return this.send(url, settings);
    };
    HttpClient.isCrossDomainRequest = function (url) {
        var uri = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__misc__["a" /* parseUrl */])(url);
        var location = document.location;
        return location.protocol !== uri.protocol
            || location.host !== uri.host;
    };
    return HttpClient;
}());

//# sourceMappingURL=HttpClient.js.map

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpClient__ = __webpack_require__(48);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__HttpClient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpException__ = __webpack_require__(10);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// https://github.com/jaubourg/ajaxHooks
if (window.XDomainRequest) {
    jQuery.ajaxTransport(function (s) {
        if (s.crossDomain && s.async) {
            if (s.timeout) {
                s.xdrTimeout = s.timeout;
                delete s.timeout;
            }
            var xdr_1;
            return {
                send: function (_, complete) {
                    function callback(status, statusText, responses, responseHeaders) {
                        xdr_1.onload = xdr_1.onerror = xdr_1.ontimeout = jQuery.noop;
                        xdr_1 = undefined;
                        complete(status, statusText, responses, responseHeaders);
                    }
                    xdr_1 = new XDomainRequest();
                    xdr_1.onload = function () {
                        callback(200, "OK", { text: xdr_1.responseText }, "Content-Type: " + xdr_1.contentType);
                    };
                    xdr_1.onerror = function () {
                        callback(404, "Not Found");
                    };
                    xdr_1.onprogress = function () {
                        window.console && window.console.log('progress');
                    };
                    xdr_1.ontimeout = function () {
                        callback(0, "timeout");
                    };
                    xdr_1.timeout = s.xdrTimeout || Number.MAX_VALUE;
                    xdr_1.open(s.type, s.url);
                    xdr_1.send((s.hasContent && s.data) || null);
                },
                abort: function () {
                    if (xdr_1) {
                        window.console && window.console.log('abort');
                        xdr_1.onerror = jQuery.noop;
                        xdr_1.abort();
                    }
                }
            };
        }
    });
}
//# sourceMappingURL=xdr.js.map

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogExceptionsDisable */
/* harmony export (immutable) */ __webpack_exports__["a"] = LogExceptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__leadsraiser_index__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_typeUtils__ = __webpack_require__(5);


var logExceptionsDisableKey = '__log_exceptions_disable';
function logExceptionsInMethods(target) {
    var excludedMethods = ['constructor'];
    if (target.hasOwnProperty(logExceptionsDisableKey)) {
        excludedMethods.push.apply(excludedMethods, target[logExceptionsDisableKey]);
    }
    for (var propertyName in target) {
        if (target.hasOwnProperty(propertyName)) {
            logExceptionsInMethod(target, propertyName, excludedMethods);
        }
    }
}
function logExceptionsInMethod(target, propertyName, excludedMethods) {
    var method = target[propertyName];
    if (__WEBPACK_IMPORTED_MODULE_1__misc_typeUtils__["e" /* isFunction */](method) && excludedMethods.indexOf(propertyName) < 0) {
        target[propertyName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                var result = method.apply(this, args);
                if (!__WEBPACK_IMPORTED_MODULE_1__misc_typeUtils__["a" /* isUndefined */](result)) {
                    Promise.resolve(result).then(undefined, function (reason) {
                        if (reason instanceof Error) {
                            __WEBPACK_IMPORTED_MODULE_0__leadsraiser_index__["a" /* lr */].api.registerException(reason);
                        }
                        else {
                            __WEBPACK_IMPORTED_MODULE_0__leadsraiser_index__["a" /* lr */].api.registerError('Promise has been rejected', null, {
                                reason: reason
                            });
                        }
                        return Promise.reject(reason);
                    });
                }
                return result;
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_0__leadsraiser_index__["a" /* lr */].api.registerException(e);
                throw e;
            }
        };
    }
}
function LogExceptionsDisable() {
    return function (target, propertyKey, descriptor) {
        var disabledMethods = [];
        if (target.hasOwnProperty(logExceptionsDisableKey)) {
            disabledMethods = target[logExceptionsDisableKey];
        }
        else {
            target[logExceptionsDisableKey] = disabledMethods;
        }
        disabledMethods.push(propertyKey);
    };
}
function LogExceptions(logStatic) {
    if (logStatic === void 0) { logStatic = false; }
    return function (target, propertyKey) {
        try {
            if (propertyKey) {
                var excludedMethods = ['constructor'];
                if (target.hasOwnProperty(logExceptionsDisableKey)) {
                    excludedMethods.push.apply(excludedMethods, target[logExceptionsDisableKey]);
                }
                logExceptionsInMethod(target, propertyKey, excludedMethods);
            }
            else {
                logExceptionsInMethods(target.prototype); // instance
                if (logStatic) {
                    logExceptionsInMethods(target); // static
                }
            }
        }
        catch (e) {
            __WEBPACK_IMPORTED_MODULE_0__leadsraiser_index__["a" /* lr */].api.registerException(e);
        }
    };
}
//# sourceMappingURL=LogExceptions.js.map

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LogExceptions__ = __webpack_require__(51);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__LogExceptions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logger__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LogLevel__ = __webpack_require__(3);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__LogLevel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trace__ = __webpack_require__(13);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Trace__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function delay(timeout) {
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, timeout); });
}
//# sourceMappingURL=delay.js.map

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objectKeysToLowerCase__ = __webpack_require__(15);


// usage:
//               [variable] [directive] [directive parameter]
// interpolate('<h1>{title | transform | uppercase}</h1>',
//             { title: 'page title' },
//             {
//                  transform: (source, transformation) => {
//                      switch (transformation) {
//                          case 'uppercase': return source.toUpperCase();
//                          case 'lowercase': return source.toLowerCase();
//                          case 'invert': return source.split('').map(char => char === char.toUpperCase() ? char.toLowerCase() : char.toUpperCase());
//                          default: return source;
//                      }
//                  }
//             })
//
function interpolate(template, replacements, directives) {
    return (template || "").replace(/\{([\w\d_]+(?:\s*\|[^}]+)*)\}/g, function (match, expression) {
        replacements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__objectKeysToLowerCase__["a" /* default */])(replacements);
        var variable = expression.split('|'), variableName = variable[0].trim().toLowerCase();
        var value = replacements[variableName];
        if (typeof (value) === 'function')
            value = value();
        directives = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __assign */]({}, interpolate.directives, directives);
        var directive = variable.length >= 2 && directives[variable[1].trim()];
        if (directive) {
            var params = variable.slice(2).map(function (param) { return param.trim(); });
            value = directive.apply(variableName, [value].concat(params));
        }
        return value == null ? '' : value;
    });
}
interpolate.directives = {
    uppercase: function (source) { return source ? source.toUpperCase() : source; },
    lowercase: function (source) { return source ? source.toLowerCase() : source; },
    escape: function (source) { return source ? encodeURIComponent(source) : source; }
};
/* harmony default export */ __webpack_exports__["a"] = (interpolate);
//# sourceMappingURL=interpolate.js.map

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var anchor;
/* harmony default export */ __webpack_exports__["a"] = (function (url) {
    if (!anchor)
        anchor = document.createElement("a");
    anchor.href = url;
    if (!anchor.protocol)
        anchor.protocol = document.location.protocol;
    if (!anchor.host)
        anchor.host = document.location.host;
    return anchor;
});
;
//# sourceMappingURL=parseUrl.js.map

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// abc.messenger.ws.js